import React, { useState,useEffect } from "react";
import { apiUrl, brands } from "../config/config";
import { setStorage } from "../utils/storage";
import { useNavigate } from "react-router-dom";
import SEO from "./SEO";

function Signup() {
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
  const user = localStorage.getItem("user");
  if (user) {
    window.location.href = "/account";
  }
}, []);

  // Handle input change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    // Validate password match
    if (form.password !== form.confirmPassword) {
      setErrorMsg("Passwords do not match!");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${apiUrl}/api/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          password: form.password,
          brand:brands,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setErrorMsg(data.message || "Registration failed");
      } else {
        setSuccessMsg("Account created successfully!");
        setStorage("user", data.user);
        window.location.href = "/";
        setForm({
          name: "",
          email: "",
          password: "",
          confirmPassword: "",
        });
      }
    } catch (err) {
      setErrorMsg("Something went wrong, try again!");
    }

    setLoading(false);
  };


  return (
    <>
          <SEO
                    title='Sign up'
                    description='Blank Beanies'
                    keywords='Blank Beanies'
                  />
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">

      {/* CARD */}
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">

        {/* Title */}
        <h2 className="text-3xl font-bold text-center mb-3">Create Account</h2>
        <p className="text-center text-gray-600 mb-8">
          Join us and get started!
        </p>


        {errorMsg && (
          <p className="text-red-500 text-center mb-3 font-medium">{errorMsg}</p>
        )}

        {/* Success */}
        {successMsg && (
          <p className="text-green-600 text-center mb-3 font-medium">{successMsg}</p>
        )}

        {/* FORM */}
        <form className="space-y-5" onSubmit={handleSubmit}>

          {/* NAME */}
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Full Name
            </label>
            <input
              type="text"
              placeholder="John Doe"
              name="name"
              value={form.name}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-3 
              focus:ring-2 focus:ring-black focus:outline-none"
            />
          </div>

          {/* EMAIL */}
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="you@example.com"
              className="w-full border border-gray-300 rounded-lg px-4 py-3 
              focus:ring-2 focus:ring-black focus:outline-none"
            />
          </div>

          {/* PASSWORD */}
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Password
            </label>

            <div className="relative">
              <input
                type={showPass ? "text" : "password"}
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Create a password"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 
                focus:ring-2 focus:ring-black focus:outline-none"
              />

              <button
                type="button"
                onClick={() => setShowPass(!showPass)}
                className="absolute right-3 top-3 text-gray-500 hover:text-black"
              >
                {showPass ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          {/* CONFIRM PASSWORD */}
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Confirm Password
            </label>

            <div className="relative">
              <input
                type={showConfirmPass ? "text" : "password"}
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                placeholder="Re-enter password"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 
                focus:ring-2 focus:ring-black focus:outline-none"
              />

              <button
                type="button"
                onClick={() => setShowConfirmPass(!showConfirmPass)}
                className="absolute right-3 top-3 text-gray-500 hover:text-black"
              >
                {showConfirmPass ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          {/* TERMS CHECKBOX */}
          {/* <div className="flex items-center gap-3 text-sm">
            <input type="checkbox" className="w-4 h-4" />
            <p>
              I agree to the{" "}
              <a href="#" className="text-black font-semibold hover:underline">
                Terms & Conditions
              </a>
            </p>
          </div> */}

          {/* SIGNUP BUTTON */}
          <button
            type="submit"
            className="w-full bg-black text-white py-3 rounded-lg text-lg font-semibold 
            hover:bg-gray-900 transition"
          >
            Create Account
          </button>
        </form>

        {/* LOGIN LINK */}
        <p className="text-center mt-6 text-sm">
          Already have an account?{" "}
          <a href="/login" className="text-black font-semibold hover:underline">
            Login
          </a>
        </p>

      </div>
    </div>
    </>
  );
}

export default Signup;
